/**
 * 493427 — quanto do topo da janela o cabeçalho do app cobre. Quem precisa disso é código que
 * posiciona algo "colado no topo" (`position: sticky`) ou que rola a página até um elemento: sem
 * descontar o cabeçalho, o alvo para debaixo dele.
 *
 * MEDIDO, não constante: a altura do `.main-header` varia com a largura da janela (o conteúdo
 * quebra em mais de uma linha) e com o que a tela mostra, e o `max-height: 108px` de
 * Content/layout.css é teto, não altura. Antes disto havia um `ALTURA_CABECALHO_FIXO = 120`
 * chutado em PesquisarClienteContainer — chute que erra nos dois sentidos.
 *
 * Devolve 0 quando o cabeçalho não é fixo: aí ele rola junto com a página e não cobre nada. Vale
 * lembrar que neste app ele É fixo — `_Base.cshtml` põe a classe `fixed` no `<body>` nos dois
 * ramos do if, e é ela que ativa o `position: fixed` do `.fixed .main-header` em layout.css. O
 * teste continua aqui porque é ele que mantém a função correta se essa classe mudar.
 */
export const obterAlturaCabecalhoFixo = (): number => {
    if (typeof document === "undefined") return 0

    const cabecalho = document.querySelector(".main-header") as HTMLElement
    if (cabecalho == null) return 0

    if (window.getComputedStyle(cabecalho).position !== "fixed") return 0

    // `bottom` e não `height`: se algum dia o cabeçalho ganhar um deslocamento próprio (outra barra
    // acima dele), é a base dele que diz onde a área livre começa de fato.
    return Math.max(0, cabecalho.getBoundingClientRect().bottom)
}

export default obterAlturaCabecalhoFixo
